import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';

import RetailerSelector from './RetailerSelector';
import ReplenishmentStrategySelector from './ReplenishmentStrategySelector';

const storeData = {
    retailerGln: '',
    storeGln: '',
    street: '',
    zipCode: '',
    city: '',
    confederation: '',
    replenishmentStrategy: ''
};

class CreateStoreModal extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = storeData;

        this.cancel = this.cancel.bind(this);
        this.setProperty = this.setProperty.bind(this);
        this.submit = this.submit.bind(this);
    }

    cancel() {
        this.setState(storeData);
        this.props.onCancel();
    }

    setProperty(propertyName, propertyValue) {
        const property = {[propertyName]: propertyValue};
        this.setState(property);
    }

    submit() {
        //validate
        this.props.onSubmit(this.state);
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            this.setState(storeData);
        }
    }

    render() {
        return (
            <Modal isOpen={this.props.visible} centered={true} className={this.props.className}>
                <ModalHeader>Neuer Store</ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-lg-12">
                            <form>
                                <div className="form-group">
                                    <label htmlFor="csModalRetailerGln">Händler</label>
                                    <RetailerSelector retailers={this.props.retailers} showPleaseSelectOpt={true}
                                                      value={this.state.retailerGln} width='350px'
                                                      onChange={(value) => this.setProperty('retailerGln', value)}/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="csModalStoreGln">Store-GLN</label>
                                    <input type="text" className="form-control" id="csModalStoreGln"
                                           onChange={(event) => this.setProperty('storeGln', event.target.value)}
                                           placeholder="GLN..." required={true}/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="csModalStoreStreet">Straße</label>
                                    <input type="text" className="form-control" id="csModalStoreStreet"
                                           onChange={(event) => this.setProperty('street', event.target.value)}
                                           placeholder="Straße..." required={true}/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="csModalStoreZipCode">PLZ</label>
                                    <input type="text" className="form-control" id="csModalStoreZipCode"
                                           onChange={(event) => this.setProperty('zipCode', event.target.value)}
                                           placeholder="PLZ..." required={true}/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="csModalStoreCity">Ort</label>
                                    <input type="text" className="form-control" id="csModalStoreCity"
                                           onChange={(event) => this.setProperty('city', event.target.value)}
                                           placeholder="Stadt..." required={true}/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="csModalStoreConfed">Verband</label>
                                    <input type="text" className="form-control" id="csModalStoreConfed"
                                           onChange={(event) => this.setProperty('confederation', event.target.value)}
                                           placeholder="Verband..."/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="csModalStoreReplenishmentStrategy">Nachschub-Auslöser</label>
                                    <ReplenishmentStrategySelector value={this.state.replenishmentStrategy}
                                        showPleaseSelectOpt={true}
                                        onChange={(value) => this.setProperty('replenishmentStrategy', value)}/>
                                </div>
                            </form>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.submit}>Store anlegen</Button>{' '}
                    <Button color="secondary" onClick={this.cancel}>Abbrechen</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default CreateStoreModal;



// WEBPACK FOOTER //
// ./src/admin/retailer/CreateStoreModal.js